import { Col, Drawer, Row, Typography } from "antd";
import { FC, useState } from "react";
import WrapperBadge from "./WrapperBadge";
import CardItemCarouselIndex from "./CardItemCarouselIndex";
import { Link } from "react-router-dom";
import PriceFormatter from "apps/Common/PriceFormatter";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import { MazakaButton } from "apps/Common/MazakaButton";
import { SearchOutlined, UserOutlined } from "@ant-design/icons";
import { MazakaDrawer } from "apps/Common/MazakaDrawer";
import AddOrUpdateIndex from "apps/CustomerPanel/MLS/Components/AddOrUpdate/AddOrUpdateIndex";
import RegisterPotentialAdIndex from "apps/CustomerPanel/MLS/Components/PotentialAds/Components/RegisterPotentialAdIndex";
import TrackingPriceIndex from "apps/CustomerPanel/Favorite/Pages/TrackingPrice/TrackingPriceInex";

import AdvertOptions from "./AdvertOptions";
import useCapitalize from "apps/Common/Adress/helpers/useCapitalize";
import TruncatedText from "apps/Common/TruncatedText";
import { useQueryClient } from 'react-query';
import lastViewedEndPoints from "apps/RealState/LastViewed/EndPoints"
import { slugify } from "../../utils/slugify";
import { Tooltip } from "antd";

interface RealStateCardViewItemProps {
  isSliderItem?: boolean;
  item: any;
  mainItem?: any;
  pageType?: string;
  advertType?: string;
  data?: any;
  setData?: any;
}

const RealStateCardViewItem: FC<RealStateCardViewItemProps> = (props) => {
  const { Text } = Typography;
  const location = `${props.item?.neighbourhood?.name || ""} ${props.item?.district?.name || ""
    } ${props.item?.city?.name || ""}`;

  const [isShowCreateMLSDrawer, setIsShowCreateMLSDrawer] = useState(false);
  const [isShowRegisterDrawer, setIsShowRegisterDrawer] = useState(false);
  const [isShowTrackingPriceDrawer, setIsShowTrackingPriceDrawer] =
    useState(false);
  const isBoldFontColored = props.item?.dopingList?.find((item: any) =>
    item?.id === 10
  );

  console.log(props.item)


  const queryClient = useQueryClient()

  return (
    <>
      <div style={{ borderRadius: "6px", borderTop: "none", border: "1px solid #e5e7ec" }}
        className={` mb-5 shadow-sm
          group
          ${isBoldFontColored ? "!bg-blue-50" : ""}
          ${props?.pageType === "showcase" ? "!bg-white " : ""
          }  rounded-bl-md rounded-br-md`}
      >
        <Link to={`/${slugify(props?.item?.title || 'ilan')}/detay?id=${props?.item.id}`}
        >
          <WrapperBadge item={props.item} >

            <CardItemCarouselIndex
              item={props.item}
              pageType={props.pageType}
              mainItem={props.mainItem}
              viewType="card"
              data={props.data}
              setData={props.setData}
            />
          </WrapperBadge>
        </Link>

        <div style={{ padding: "10px" }}
          className={` border-black ${props?.pageType === "showcase" ? "!p-1" : "!pt-2"
            }
          ${isBoldFontColored ? "!p-2" : ""}
          `}
        >
          <Link className="!grid gap-2" to={`/${slugify(props?.item?.title || 'ilan')}/detay?id=${props?.item.id}`}
            onClick={() => {
              queryClient.resetQueries({
                queryKey: lastViewedEndPoints.getLastViewedList,
                exact: false,
              });
            }}

          >
            <TruncatedText
              wrapperClassName="!h-[25px]  md:!h-[40px]"
              title={props.item.title}
              maxLines={2}
              textClassName={`!text-[10px]  md:!text-[16px] !text-[#3b4144] ${isBoldFontColored ? "!font-bold" : ""
                }`}
            />
            <div className=" !h-[10px] md:!h-[20px] flex justify-between items-center">
              <Row className="!flex items-center">
                <Col xs={24}>
                  <Text className="!font-bold !text-[20px] !text-[#3b4144] ">
                    <PriceFormatter
                      inputPrice={props.item.price}
                      currency={props.item?.currency?.shortName}
                    />{" "}
                  </Text>
                </Col>
              </Row>

              <div className="!flex items-center gap-6 transition-all duration-300">
                <div className="!flex items-center gap-1 ">
                  <div>
                    {props?.item?.store?.photoUrl ? (
                      <LazyLoadImage
                        wrapperWidth="50px"
                        wrapperHeight="50px"
                        src={setBackEndUlr() + "/" + props.item.store.photoUrl}
                        alt=""
                        imageClassName="!rounded-md"
                      />
                    ) : (
                      <Tooltip
                        title={
                          <div>
                            <div style={{fontSize:"10px"}}>{props.item?.user?.name} {props.item?.user?.surname}</div>
                            <div style={{fontSize:"10px"}}>E-Mail : {props.item?.user?.eMail}</div>
                            <div style={{fontSize:"10px"}}>Telefon : {props.item?.user?.phoneNumber}</div>
                          </div>
                        }
                      >
                        <div className="w-[30px] h-[30px] rounded-full bg-gray-300 flex items-center justify-center text-white font-semibold text-sm cursor-pointer">
                          {`${props.item?.user?.name?.[0] || ""}${props.item?.user?.surname?.[0] || ""}`.toUpperCase()}
                        </div>
                      </Tooltip>

                    )}
                  </div>
                  {/* <div className="!block md:!block">
                  {props?.item.store?.storeName && (
                    <TruncatedText
                      title={props?.item.store?.storeName}
                      textClassName={`!text-black !text-xs md:!text-sm ${isBoldFontColored ? "!font-bold" : ""}`}
                      maxLines={1}
                    />
                  )}

                  <div className={`${props.item?.store?.photoUrl ? "" : "!h-[25px] !flex items-center"}`}>
                    <Text
                      className={`!text-gray-400 !text-xs ${isBoldFontColored ? "!font-bold" : ""}`}
                    >
                      {`${props.item?.user?.name || ""} ${props.item?.user?.surname || ""}`}
                    </Text>
                  </div>
                </div> */}
                </div>
              </div>
            </div>


            {/* <TruncatedText
             wrapperClassName="!h-[13px] md:!h-[18px]"
             title={location}
             textClassName={`!text-[#7a868e] !text-[10px] md:!text-xs ${
              isBoldFontColored ? "!font-bold" : ""
            }`}
            maxLines={1}
             /> */}

            <div>
              <div>
                {/* {props.item.cardViewAdvertOptions && (
                  <>
                    <AdvertOptions
                      options={props?.item?.cardViewAdvertOptions}
                      type={props.item.type}
                      isBoldFontColored={isBoldFontColored}
                    />
                  </>
                )} */}
              </div>
            </div>


          </Link>
          {(props.pageType === "portfolio" ||
            props.pageType === "potentialAds" ||
            props.pageType === "favorite") && (
              <>
                <div className="!mt-2">
                  {(() => {
                    if (props.pageType === "favorite") {
                      return (
                        <>
                          <MazakaButton
                            block
                            type="primary"
                            icon={<SearchOutlined />}
                            className="!bg-[#FFC502] !text-black"
                            onClick={() => {
                              setIsShowTrackingPriceDrawer(true);
                            }}
                          >
                            Fiyatını Takip Et
                          </MazakaButton>
                        </>
                      );
                    } else if (props.pageType === "portfolio") {
                      return (
                        <>
                          {/* <MazakaButton
                            onClick={() => {
                              setIsShowCreateMLSDrawer(true);
                            }}
                            type="primary"
                            icon={
                              props.item.status ? (
                                <>
                                  <MinusOutlined />
                                </>
                              ) : (
                                <>
                                  <PlusOutlined />
                                </>
                              )
                            }
                            className={`${
                              props.item.status
                                ? "!bg-red-500"
                                : "!bg-[#FFC502]"
                            } ${
                              props.item.status ? "!text-white" : "!text-black"
                            } `}
                            block
                          >
                            {props.item.status ? "MLS Kaldır" : "MLS Ekle"}
                          </MazakaButton> */}
                        </>
                      );
                    } else if (props.pageType === "potentialAds") {
                      return (
                        <>
                          <MazakaButton
                            onClick={() => {
                              setIsShowRegisterDrawer(true);
                            }}
                            type="primary"
                            icon={<UserOutlined />}
                            className="!bg-[#FFC502] !text-black"
                            block
                          >
                            MLS Portföyüme Ekle
                          </MazakaButton>
                        </>
                      );
                    }
                    return <></>;
                  })()}
                </div>
              </>
            )}
        </div>
      </div>
      <MazakaDrawer
        title={<Text className="!font-bold !text-2xl">MLS ilan oluştur</Text>}
        description={
          <Text className="!text-sm !text-black">
            İlanınız kriterlere uygun ilk 20 kişi ile paylaşılacaktır.
          </Text>
        }
        open={isShowCreateMLSDrawer}
        toggleVisible={() => {
          setIsShowCreateMLSDrawer(!isShowCreateMLSDrawer);
        }}
      >
        <AddOrUpdateIndex />
      </MazakaDrawer>
      <MazakaDrawer
        title={<Text className="!font-bold !text-2xl">Başvur</Text>}
        open={isShowRegisterDrawer}
        toggleVisible={() => {
          setIsShowRegisterDrawer(!isShowRegisterDrawer);
        }}
      >
        <RegisterPotentialAdIndex />
      </MazakaDrawer>
      <Drawer
        open={isShowTrackingPriceDrawer}
        onClose={() => {
          setIsShowTrackingPriceDrawer(false);
        }}
        bodyStyle={{ padding: 0 }}
        width={"100%"}

      >
        <TrackingPriceIndex advertId={props.item.id} />
      </Drawer>
    </>

  );
};

export default RealStateCardViewItem;
